import { useRoutes } from 'react-router-dom';

import MainRoutes from 'routes/MainRoutes';
import BridgeRoutes from 'routes/BridgeRoutes';
import AuthRoutes from 'routes/AuthRoutes';
import LoginRoutes from 'routes/LoginRoutes';

import CloudRoutes from 'routes/CloudRoutes';
import CloudLoginRoutes from 'routes/CloudLoginRoutes';
import CloudAuthRoutes from 'routes/CloudAuthRoutes';

// ==============================|| MAIN ROUTING ||============================== //

export default function ThemeRoutes() {
  return useRoutes([MainRoutes, BridgeRoutes, AuthRoutes, LoginRoutes, CloudRoutes, CloudLoginRoutes, CloudAuthRoutes]);
}
